// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"9ca62740","234":"6a1d336b","882":"5a206510"}[chunkId] + ".chunk.js";
};